import axiosInstance from '../utils/axios';

export const GetCallLogList = async (data) => {
    return await axiosInstance().post("/getCallLogList",data);
}
export const GetCallLogsListFilters = async (str) => {
    return await axiosInstance().get(`/getCallLogsListFilters?`+str);
}

export const GetOpportunityData = async (search, cancelToken) => {
    return await axiosInstance().post('/getOpportunityData', search, {cancelToken: cancelToken});
}

export const GetContactData = async (search, cancelToken) => {
    return await axiosInstance().post('/getContactData', search, {cancelToken: cancelToken});
}

export const decryptCustomerSearchString = async (token, cancelToken) => {
    return await axiosInstance().post('/decryptCustomerSearchString', token, {cancelToken: cancelToken});
}

export const findCustomersByMobileEmailStudentNumber = async (searchData, cancelToken) => {
    return await axiosInstance().post('/findCustomersByMobileEmailStudentNumber', searchData, {cancelToken: cancelToken});
}
export const authenticateWithToken = async (data, cancelToken) => {
    return await axiosInstance().post('/authenticateWithToken', data, {cancelToken: cancelToken});
}

// Lookup student in portal DB for softphone dashboard (expects student_crm_id as student_number)
export const GetStudentDetailsForSoftPhone = async (student_number, cancelToken) => {
    return await axiosInstance().get('/getStudentDetailsforSoftPhone', {
        params: { student_number },
        cancelToken
    });
}